import React, { useState } from 'react';
import './Traitement.css';
import backgroundImage from '../Assets/industrial.PNG';
import treatment1Image from '../Assets/dynamicbalancing.PNG'; // Dynamic Balancing
import treatment2Image from '../Assets/iv11.PNG'; // CAT IV Vibration Analysis
import treatment3Image from '../Assets/Iv22.PNG'; // CAT III Vibration Analysis
import treatment4Image from '../Assets/IV33.PNG'; // CAT I Vibration Analysis
import treatment5Image from '../Assets/Iv44.PNG'; // CAT II Vibration Analysis
import treatment6Image from '../Assets/laser alignemet.PNG'; // Laser Alignment

const Traitement = () => {
  const [activeTreatment, setActiveTreatment] = useState(null);
  const [zoomedId, setZoomedId] = useState(null);

  const treatments = [
    {
      id: 1,
      title: 'Dynamic Balancing',
      description: 'Cette formation vous apprend à identifier et corriger les déséquilibres mécaniques sur les équipements rotatifs. Vous y découvrirez les principes de l’équilibrage dynamique, l’utilisation des instruments de mesure, et les techniques pour effectuer des équilibrages en un ou deux plans, conformément aux normes industrielles. Idéale pour les techniciens de maintenance et analystes vibratoires souhaitant approfondir leurs compétences pratiques.',
      image: treatment1Image,
      htmlId: 'dynamic-balancing',
    },
    {
      id: 2,
      title: 'Laser Alignment',
      description: 'Apprenez à réaliser un alignement d’arbres rapide et précis à l’aide d’un système laser. Cette formation couvre les bases de l’alignement, les effets d’un mauvais alignement sur les machines, et l’utilisation d’outils laser modernes pour garantir une mise en service optimale. Recommandée pour les équipes de maintenance mécanique cherchant à réduire l’usure, les pannes et la consommation énergétique.',
      image: treatment6Image,
      htmlId: 'laser-alignment',
    },
    {
      id: 3,
      title: 'CAT I Vibration Analysis – Basic (VCAT-I)',
      description: 'Obtenez une introduction complète à l’analyse vibratoire avec la Catégorie I. Conçue pour les techniciens de maintenance et les débutants, cette formation couvre les principes fondamentaux des vibrations, les techniques de collecte de données et la détection simple des défauts. C’est la première étape vers un programme de maintenance conditionnelle efficace.',
      image: treatment4Image,
      htmlId: 'cat-i-vibration',
    },
    {
      id: 4,
      title: 'CAT II Vibration Analysis – Intermediate (VCAT-II)',
      description: 'Approfondissez vos compétences avec la Catégorie II, destinée aux professionnels ayant une première expérience en vibration. Cette formation traite de l’analyse spectrale, du diagnostic de pannes courantes et de la validation des données. Vous serez en mesure de poser des diagnostics fiables et de prendre de meilleures décisions de maintenance.',
      image: treatment5Image,
      htmlId: 'cat-ii-vibration',
    },
    {
      id: 5,
      title: 'CAT III Vibration Analysis – Advanced (VCAT-III)',
      description: 'Développez une expertise technique avancée avec la Catégorie III. Ce niveau s’adresse aux analystes confirmés et aux ingénieurs, avec un focus sur les pannes complexes, le traitement avancé du signal et les stratégies de maintenance conditionnelle. Apprenez à gérer un programme d’analyse vibratoire et à améliorer la fiabilité des équipements.',
      image: treatment3Image,
      htmlId: 'cat-iii-vibration',
    },
    {
      id: 6,
      title: 'CAT IV Vibration Analysis – Expert (VCAT-IV)',
      description: 'Atteignez le niveau d’excellence avec la Catégorie IV, la plus haute certification. Ce cours est destiné aux experts en fiabilité souhaitant maîtriser les diagnostics avancés, la conception de systèmes de surveillance et la gestion de programmes. Devenez un leader dans la mise en œuvre de stratégies de fiabilité à long terme.',
      image: treatment2Image,
      htmlId: 'cat-iv-vibration',
    },
  ];

  console.log('Rendering Traitement component');
  console.log('backgroundImage:', backgroundImage);
  treatments.forEach(t => console.log(`treatment${t.id}Image:`, t.image));

  const handleClick = (id) => {
    setActiveTreatment(id === activeTreatment ? null : id);
    setZoomedId(id);
    setTimeout(() => setZoomedId(null), 500);
  };

  return (
    <div
      className="traitement-container"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <img src={backgroundImage} alt="Industrial background" style={{ display: 'none' }} />
      <div className="overlay">
        <div className="treatment-grid">
          {treatments.map((treatment) => (
            <div
              key={treatment.id}
              id={treatment.htmlId}
              className={`treatment-card ${zoomedId === treatment.id ? 'zoomed' : ''}`}
              onClick={() => handleClick(treatment.id)}
            >
              {activeTreatment === treatment.id ? (
                <div className="description-box">
                  <p>{treatment.description}</p>
                </div>
              ) : (
                <>
                  <img src={treatment.image} alt={treatment.title} className="treatment-image" />
                  <div className="treatment-content">
                    <h2>{treatment.title}</h2>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Traitement;